import { FC, MouseEvent } from 'react';
import { DropdownButton, DropdownButtonItem } from '@salecycle/ui-component-library';

export interface IProps {
  discard?: () => void;
  revert?: () => void;
}

export const StepControls: FC<IProps> = props => {
  const onDiscard = (event: MouseEvent<any>) => {
    event.stopPropagation();
    props.discard();
  };

  const onRevert = (event: MouseEvent<any>) => {
    event.stopPropagation();
    props.revert();
  };

  return (
    <DropdownButton variation="clean" icon="ellipsis-v" menuPlacement="right" menuMinWidth={100}>
      {props.revert && <DropdownButtonItem onClick={onRevert}>Revert Changes</DropdownButtonItem>}
      {props.discard && <DropdownButtonItem onClick={onDiscard}>Remove Rule</DropdownButtonItem>}
    </DropdownButton>
  );
};

export default StepControls;
